<template>
  <!-- 添加或修改设备调换记录对话框 -->
  <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="图片" prop="src">
          <image-upload v-model="form.url" :isShowTip="true" :limit="1" />
      </el-form-item>
        <el-form-item label="类型" prop="tags">
        <el-select
          v-model="form.tags"
          filterable
          multiple
          placeholder="请选择类型(最多选择两个)"
          @change="imageTypeChange"
        >
          <el-option
            v-for="(item, index) in typeList"
            :key="index"
            :label="item.type"
            :value="item.id"
          />
        </el-select>
   
      </el-form-item>
           <el-form-item label="类型逻辑" prop="src" v-if="form.tags.length>1">
            <el-radio-group v-model="form.tagLogic">
    <el-radio :label="0">所选必须同时满足</el-radio>
    <el-radio :label="1">满足任意一个类型即可</el-radio>
  </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { imageLibrarySearch } from "@/api/imageLibrary";
import { imageTypeList } from "@/api/imageType";
export default {
  components: {},
  data() {
    return {
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 表单参数
      form: {
        platForm: null,
        url:'',
        tags: [],
        tagLogic: null
      },
      // 表单校验
      rules: {
      },
      typeList:[]
    }
  },
  methods: {
    addCreateForm(platForm) {
      this.reset()
      this.open = true
      this.form.platForm = platForm
      this.title = '查询'
      this.getTypeList()
    },
     getTypeList() {
      imageTypeList({
        pageNum: 1,
        pageSize: 1000,
        platForm: this.form.platForm,
      }).then((response) => {
        const result = response.data.data;
        console.log(result);
        this.typeList = result.list;
      });
    },
        // 表单重置
    reset() {
      this.form = {
       platForm: null,
        url:'',
        tags: [],
        tagLogic: null
      }
    },
      imageTypeChange(value) {
      // 如果选择的值超过2个，只保留前两个
      if (value.length > 2) {
        // 还原为前两个值
        this.form.tags = value.slice(0, 2);
        // 可选：弹出提示
        this.$message.warning("最多只能选择2个选项！");
      }
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
            const data = {
                platForm: this.form.platForm,
                url: this.form.url,
                tags: this.form.tags.join(','),
                tag_logic: this.form.tagLogic
            }
            imageLibrarySearch(data).then(response => {
                this.open = false
                console.log(response)
                if(response.data.code === 200){
                  const data = JSON.parse(response.data.data)
                  const result = data.result
                  result.forEach(e => {
                    e.list = JSON.parse(e.brief)
                  });
                  console.log(result)
              this.$modal.msgSuccess("查询成功")
              this.$emit('ok',result)
                }else{
                    this.$modal.msgError(response.data.msg)
                }
            })
        }
      })
    },
    // 取消按钮
    cancel() {
      this.reset()
      this.open = false
    }
  },
  mounted() {
  }
}
</script>

<style></style>
